import React from 'react';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  CardDescription,
} from '../ui/card';
import { Button } from '../ui/button';
import { Label } from '../ui/label';
import { Smartphone, Check } from 'lucide-react';

interface TwoFactorAuthProps {
  twoFactorEnabled: boolean;
  onToggle: () => void;
  description?: string;
  contentDescription?: string;
}

const TwoFactorAuth = ({
  twoFactorEnabled,
  onToggle,
  description,
  contentDescription = 'Add an extra layer of security to your account',
}: TwoFactorAuthProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center space-x-2 text-base sm:text-lg">
          <Smartphone className="h-5 w-5 flex-shrink-0" />
          <span>Two-Factor Authentication</span>
        </CardTitle>
        {description && <CardDescription>{description}</CardDescription>}
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
          <div className="space-y-0.5">
            <Label className="text-sm">Enable 2FA</Label>
            <p className="text-xs sm:text-sm text-muted-foreground">
              {contentDescription}
            </p>
          </div>
          <Button
            variant={twoFactorEnabled ? 'default' : 'outline'}
            size="sm"
            onClick={onToggle}
          >
            {twoFactorEnabled ? 'Enabled' : 'Enable'}
          </Button>
        </div>
        {twoFactorEnabled && (
          <div className="p-4 bg-green-50 border border-green-200 rounded-lg">
            <div className="flex items-center space-x-2 text-green-800">
              <Check className="h-4 w-4" />
              <span className="text-sm font-medium">
                Two-factor authentication is enabled
              </span>
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default TwoFactorAuth;
